import apiClient from '@/lib/axios';
import type { LeadNote, ApiResponse } from '../types';

/**
 * Get all notes for a lead
 * @param leadId - The ID of the lead
 * @returns Array of lead notes
 */
export async function getLeadNotes(leadId: number): Promise<LeadNote[]> {
  const response = await apiClient.get<ApiResponse<LeadNote[]>>(
    `/leads/${leadId}/notes`
  );
  return response.data.data;
}

/**
 * Add a new note to a lead
 * @param leadId - The ID of the lead
 * @param noteText - The text content of the note
 * @returns The created lead note
 */
export async function addLeadNote(
  leadId: number,
  noteText: string
): Promise<LeadNote> {
  const response = await apiClient.post<ApiResponse<LeadNote>>(
    `/leads/${leadId}/notes`,
    { noteText }
  );
  return response.data.data;
}
